<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-row no-gutters>
          <v-col v-if="!!value.items.length" class="pa-2" cols="12">
            <v-expansion-panels v-if="value.items.length > 0" class="pa-2">
              <v-expansion-panel
                v-for="({ section }, i) in value.items"
                :key="i"
                class="rounded-lg mb-2"
                @click="openDialog(i)"
              >
                <v-expansion-panel-header hide-actions>
                  <div class="d-flex" style="color: inherit !important">
                    <div class="rowinfo" style="color: inherit !important">
                      <v-btn outlined style="color: inherit !important">
                        {{ $t("section.edit_part") }}
                        {{ section.title || i + 1 }}
                        <v-icon right small>mdi-pencil</v-icon>
                      </v-btn>
                      <help-info
                        v-show="i === 0"
                        :element-name="`${serviceName}-${componentName}-section-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('section.edit_part')"
                      />
                    </div>

                    <v-spacer />
                    <v-btn
                      icon
                      @click.stop="valueComputed.items.splice(index, 1)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <help-info
                      v-show="i === -1"
                      left
                      :element-name="`${serviceName}-${componentName}-valueComputed-item`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('section.edit_part')"
                    />
                  </div>
                </v-expansion-panel-header>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-divider />

            <service-section-card
              v-model="value.items[index].section"
              :dialog.sync="dialog"
              :index="index + 1"
            />
          </v-col>

          <v-col cols="12">
            <div class="rowinfo" style="width: 100% !important">
              <v-btn
                color="success"
                outlined
                @click="addNewSection"
                class="contentinfo"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-addNewSection`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('add_section')"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import ServiceSectionCard from "./serviceSectionCard";

export default {
  name: "ServiceSection",

  components: { ServiceSectionCard },

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "service-section",
      dialog: false,
      index: 0,
    };
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    valueComputed: {
      deep: true,
      handler(val) {
        console.log(val);
      },
    },
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    addNewSection() {
      this.valueComputed.items.push({
        section: {
          title: "",
          text: this.$t("add_new_text_section"),
          button: {
            title: this.$t("btn_title_section"),
            icon: "mdi-ballot-recount",
            background: "linear-gradient(to right , #1AD0D8FF, #2115A7FF)",
            color: "#ffffffff",
            link: this.$coreterminalUrl,
            target: "_blank",
          },
          text_position: "left",
          object: {
            type: "image",
            url: this.$cdnUrl + "/upload/64b1535578ce0.webp",
          },
        },
      });
    },
    openDialog(index) {
      this.dialog = true;
      this.index = index;
    },
  },
};
</script>
